export const MAX_FILE_SIZE = 10485760; // 10485760 bytes (10 mb) = 10 * 1024 * 1024

// Dropzone MIME types
export const GENERAL_FILE_TYPES = [
  ".jpg",
  ".png",
  ".pdf",
  ".csv",
  ".doc",
  ".docx",
  ".xls",
  ".xlsx",
  ".txt"
];
export const COMPLETED_FORM_TYPES = [".pdf"];

// Dropzone hints
export const GENERAL_FILE_HINT =
  "File type limited to jpg, png, txt, xlxs, xls, doc, docx, csv, pdf - Max number of files is 10. Each file 10MB or less";
export const GENERAL_FILE_HINT_25_FILE_LIMIT =
  "File type limited to jpg, png, txt, xlxs, xls, doc, docx, csv, pdf - Max number of files is 25. Each file 10MB or less";
export const COMPLETED_FORM_HINT = "Upload one .pdf file";
export const GENERAL_ONE_FILE_HINT =
  "File type limited to jpg, png, txt, xlxs, xls, doc, docx, csv, pdf - Upload one file of 10MB or less";
